import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	employeeAssignedAsset: {
		requesting: false,
		items: [],
		pagination: {
			current_page: 1,
			per_page: 10,
			total: 0,
		},
		error: null,
		success: false,
		filters: {},
	},
	employeeAssignedAssetDetails: {
		requesting: false,
		data: null,
		error: null,
		success: false,
	},

	assetOptions: {
        requesting: false,
        items: [],
        error: null,
        success: false,
    },
};

export const employeeEmployeeAssignedAssetSlice = createSlice({
	name: "employeeAssignedAsset",
	initialState,
	reducers: {
		getEmployeeAssignedAssetList: (state, action) => {
			state.employeeAssignedAsset.requesting = true;
			state.employeeAssignedAsset.error = null;
			state.employeeAssignedAsset.items = [];
			state.employeeAssignedAsset.success = false;
			state.employeeAssignedAsset.filters = action.payload;
		},
		getEmployeeAssignedAssetListSuccess: (state, action) => {
			const { data, current_page, per_page, total } = action.payload;

			state.employeeAssignedAsset.requesting = false;
			state.employeeAssignedAsset.items = data;
			state.employeeAssignedAsset.success = true;
			state.employeeAssignedAsset.pagination.current_page = current_page;
			state.employeeAssignedAsset.pagination.per_page = per_page;
			state.employeeAssignedAsset.pagination.total = total;
		},
		getEmployeeAssignedAssetListFail: (state, action) => {
			state.employeeAssignedAsset.requesting = false;
			state.employeeAssignedAsset.error = action.payload;
		},

		getEmployeeAssignedAssetDetails: (state) => {
			state.employeeAssignedAssetDetails.requesting = true;
			state.employeeAssignedAssetDetails.error = null;
			state.employeeAssignedAssetDetails.data = null;
			state.employeeAssignedAssetDetails.success = false;
		},
		getEmployeeAssignedAssetDetailsSuccess: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.data = action.payload;
			state.employeeAssignedAssetDetails.success = true;
		},
		getEmployeeAssignedAssetDetailsFail: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.error = action.payload;
		},

		doEmployeeAssignedAssetCreate: (state) => {
			state.employeeAssignedAssetDetails.requesting = true;
			state.employeeAssignedAssetDetails.error = null;
			state.employeeAssignedAssetDetails.data = null;
			state.employeeAssignedAssetDetails.success = false;
		},
		doEmployeeAssignedAssetCreateSuccess: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.data = action.payload;
			state.employeeAssignedAssetDetails.success = true;
		},
		doEmployeeAssignedAssetCreateFail: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.error = action.payload;
			state.employeeAssignedAssetDetails.success = false;
		},

		doEmployeeAssignedAssetUpdate: (state) => {
			state.employeeAssignedAssetDetails.requesting = true;
			state.employeeAssignedAssetDetails.error = null;
			state.employeeAssignedAssetDetails.data = null;
			state.employeeAssignedAssetDetails.success = false;
		},
		doEmployeeAssignedAssetUpdateSuccess: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.data = action.payload;
			state.employeeAssignedAssetDetails.success = true;
		},
		doEmployeeAssignedAssetUpdateFail: (state, action) => {
			state.employeeAssignedAssetDetails.requesting = false;
			state.employeeAssignedAssetDetails.error = action.payload;
			state.employeeAssignedAssetDetails.success = false;
		},

		doEmployeeAssignedAssetDelete: (state) => {
			state.employeeAssignedAssetDetails.requesting = true;
			state.employeeAssignedAssetDetails.error = null;
			state.employeeAssignedAssetDetails.data = null;
			state.employeeAssignedAssetDetails.success = false;
		},

		doEmployeeAssignedAssetReset: (state) => {
			state.employeeAssignedAssetDetails.data = null;
		},
		getAssetOptions: (state) => {
			state.assetOptions.requesting = true;
			state.assetOptions.error = null;
			state.assetOptions.items = [];
			state.assetOptions.success = false;
		},

		getAssetOptionsSuccess: (state, action) => {
			state.assetOptions.requesting = false;
			state.assetOptions.items = action.payload;
			state.assetOptions.success = true;
		},

		getAssetOptionsFail: (state, action) => {
			state.assetOptions.requesting = false;
			state.assetOptions.error = action.payload;
		},
	},
});

export const {
	getEmployeeAssignedAssetList, getEmployeeAssignedAssetListSuccess,
	getEmployeeAssignedAssetListFail, getEmployeeAssignedAssetDetails,
	getEmployeeAssignedAssetDetailsSuccess, getEmployeeAssignedAssetDetailsFail,
	doEmployeeAssignedAssetCreate, doEmployeeAssignedAssetCreateSuccess,
	doEmployeeAssignedAssetCreateFail, doEmployeeAssignedAssetUpdate,
	doEmployeeAssignedAssetUpdateSuccess, doEmployeeAssignedAssetUpdateFail,
	doEmployeeAssignedAssetDelete, doEmployeeAssignedAssetReset,
	getAssetOptions, getAssetOptionsSuccess,
    getAssetOptionsFail,
} = employeeEmployeeAssignedAssetSlice.actions;

export default employeeEmployeeAssignedAssetSlice.reducer;